angular.module('unica_report.report_controllers', [])

.controller('ReportBasicController', function() {

});

